import React, { useState } from "react";
import reduceToInitials from "venuescanner-js/helpers/reduceToInitials";

const Avatar = ({ imageUrl, names, size, isCircle, alert, concierge }) => {
  const [imageHasLoaded, setImageHasLoaded] = useState(false);

  return (
    <div
      className={`avatar avatar--${size} ${isCircle ? "isCircle" : ""} ${
        concierge === true ? "isConcierge" : ""
      }`}
    >
      <div className="avatar__wrapper">
        <span className="avatar__initials">{reduceToInitials(...names)}</span>
        {imageUrl !== null && (
          <img
            className={`avatar__image ${
              imageHasLoaded && "avatar__image--hasLoaded"
            }`}
            alt={`${names} ${
              imageUrl !== null ? "profile picture" : "profile initials"
            } `}
            src={imageUrl}
            srcSet={`${imageUrl}, ${imageUrl * 2}`}
            onLoad={() => setImageHasLoaded(true)}
          />
        )}
      </div>
      {concierge && concierge !== true ? (
        <span className="avatar__concierge" title={`Concierge: ${concierge}`}>
          {concierge}
        </span>
      ) : null}
      {alert && (
        <span
          className={`avatar__notification avatar__notification--${alert}`}
        ></span>
      )}
    </div>
  );
};

export default Avatar;
